import axios from "axios";

const storeRTM = function(rtm, time) {
	if  ( localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData')) && JSON.parse(localStorage.getItem('userData')).sessionData ) 
		{
			var classId = JSON.parse(localStorage.getItem('userData')).sessionData.id;
			var postData = { classId: classId, rtm: rtm, time: time };
			axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/addClassRtm", postData).then(res => { }).catch(err =>{ }); 
		}
}

export { storeRTM } 